import "@/index.css";
import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import { App } from "@/App";

void (async () => {
  try {
    window.env = await fetch("/api/env").then((res) => res.json());
  } catch (_error) {
    return;
  }

  if (window.env.APP_ENV === "production") {
    const noop = () => undefined;
    window.console.log = noop;
    window.console.debug = noop;
    window.console.info = noop;
  }

  if (window.env.SENTRY_ENABLED) {
    Sentry.init({
      dsn: window.env.SENTRY_DSN,
      environment: window.env.APP_ENV,
      release: window.env.APP_BUILD,
    });
  }

  // Render the app
  const rootElement = document.getElementById("root");

  if (!rootElement) {
    throw new Error("Root element not found");
  }

  if (!rootElement.innerHTML) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(<App />);
  }
})();
